import { formatDkk } from '@jywer/ui';
import { SUBSCRIPTION_LABEL, type MrrByTypeRow } from './types';

const COLORS = [
  'bg-accent',
  'bg-emerald-500',
  'bg-amber-500',
  'bg-violet-500',
  'bg-indigo-500',
  'bg-sky-500',
  'bg-rose-500',
  'bg-slate-500',
];

export function MrrStackedBar({ rows }: { rows: MrrByTypeRow[] }) {
  const total = rows.reduce((acc, r) => acc + Number(r.mrr ?? 0), 0);
  if (total === 0) {
    return <p className="text-sm text-ink-2">Ingen aktive abonnementer.</p>;
  }
  return (
    <div className="flex flex-col gap-2">
      <div className="flex h-4 overflow-hidden rounded bg-paper-2">
        {rows.map((r, i) => {
          const pct = (Number(r.mrr) / total) * 100;
          if (pct === 0) return null;
          return (
            <div
              key={r.subscription_type}
              className={COLORS[i % COLORS.length]}
              style={{ width: `${pct}%` }}
              title={`${SUBSCRIPTION_LABEL[r.subscription_type] ?? r.subscription_type}: ${formatDkk(r.mrr)} (${pct.toFixed(1)}%)`}
            />
          );
        })}
      </div>
      <ul className="flex flex-col gap-1 text-xs">
        {rows.map((r, i) => (
          <li
            key={r.subscription_type}
            className="flex items-center justify-between gap-3 text-ink-2"
          >
            <span className="flex items-center gap-2">
              <span
                className={`inline-block h-2.5 w-2.5 rounded-sm ${COLORS[i % COLORS.length]}`}
                aria-hidden="true"
              />
              <span>{SUBSCRIPTION_LABEL[r.subscription_type] ?? r.subscription_type}</span>
              <span className="text-ink-3">· {r.active_count} aktive</span>
            </span>
            <span className="tabular-nums text-ink-1">{formatDkk(r.mrr)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
